import { render, staticRenderFns } from "./AllApprovalsLogs.vue?vue&type=template&id=6217a57c&"
import script from "./AllApprovalsLogs.vue?vue&type=script&lang=js&"
export * from "./AllApprovalsLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports